import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import { ContactSection, TopicsSection, RankingSection, UpdatesSection } from './components/SectionsGroup1';
import { MediaSection, FaqSection, CardsSection, FeaturesSection } from './components/SectionsGroup2';
import { AppSection, AboutSection, IndexSection, CarouselSection, CommentsSection } from './components/SectionsGroup3';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <ContactSection />
        <TopicsSection />
        <RankingSection />
        <UpdatesSection />
        <MediaSection />
        <FaqSection />
        <CardsSection />
        <FeaturesSection />
        <AppSection />
        <AboutSection />
        <IndexSection />
        <CarouselSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}